var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-title',[_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('overview.tasks')))])]),_c('v-card-text',[_c('v-row',[_c('v-col',[_c('task-list',{attrs:{"tasks":_vm.tasks}})],1)],1)],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }